import { ServiceAppService } from "../../../security/service-app.service";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-upload-image",
  templateUrl: "./upload-image.component.html",
  styleUrls: ["./upload-image.component.css"],
})
export class UploadImageComponent implements OnInit {
  tipoImagem: number;
  erro: any[];

  constructor(
    private service: ServiceAppService,
  ) {}

  ngOnInit() {
    this.tipoImagem = 1;
  }

  onUpload(event: any): void {
    const file = event.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const base64Image = (reader.result as string).split(",")[1];
      const payload = { image: base64Image };
      var image = new Image();
      if (typeof e.target.result === "string") {
        image.src = e.target.result;

        image.onload = () => {
          const maxHeight = 170;
          const maxWidth = 170;

          if (this.tipoImagem == 1) {
            this.service.postArquivo("/alterar_imagem/uploadFundo", payload).subscribe(
              (_response) => { window.location.reload(); }, 
              (_erro) => {
                this.erro = [
                  {
                    severity: "error",
                    summary: "Erro",
                    detail: `Ocorreu algum erro interno, tente novamente mais tarde.`,
                  },
                ];
              }
            );

          } else if (this.tipoImagem == 2) {
            if (image.width <= maxWidth && image.height <= maxHeight) {
              this.service.postArquivo("/alterar_imagem/uploadLogo", payload).subscribe(
                (_response) => { window.location.reload(); }
              );
            } else {
              this.erro = [
                {
                  severity: "error",
                  summary: "Imagem Inválida",
                  detail: `A imagem excede as dimensões permitidas de ${maxWidth} x ${maxHeight}px.`,
                },
              ];
            }
          } else if (this.tipoImagem == 3) {
            if (image.width <= maxWidth && image.height <= maxHeight) {
              this.service.postArquivo("/alterar_imagem/uploadLogoOsMontadora", payload).subscribe(
                (_response) => { window.location.reload(); }
              );
            } else {
              this.erro = [
                {
                  severity: "error",
                  summary: "Imagem Inválida",
                  detail: `A imagem excede as dimensões permitidas de ${maxWidth} x ${maxHeight}px.`,
                },
              ];
            }
          } else if (this.tipoImagem == 4) {
            this.service.postArquivo("/alterar_imagem/uploadImagemAuxiliar", payload).subscribe(
              (_response) => { window.location.reload(); },
              (_erro) => {
                this.erro = [
                  {
                    severity: "error",
                    summary: "Erro",
                    detail: `Ocorreu algum erro interno, tente novamente mais tarde.`,
                  },
                ];
              }
            );
          }
        };
      }
    };
    reader.readAsDataURL(file);
  }
}

 